import React from "react";
import { Collapse, SimpleForm as Form, Input, Switch, Radio, InputNumber, Tooltip } from '@whalecloud/fdx';
import { set } from "dot-prop-immutable";
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import { createTableRowCell } from "@whalecloud/page-builder-core/utils/elementUtils";

const { Panel } = Collapse;

const valueKey = 'data.columnSettings';

const HeaderCellSettings = ({ element, updateElement }) => {
  const messages = getLocale();

  const { columnSettings = {} } = element.data;
  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      let newElement;
      if (key === 'openRender') {
        // 开启/关闭自定义渲染
        // const renderKey = `${valueKey}.render`
        if (obj[key]) {
          newElement = set(element, 'elements', [createTableRowCell()]);
        } else {
          // newElement = set(element, renderKey, (text, record, index) => text);
        }
      } else {
        const value = obj[key];
        newElement = set(element, propName, value);
      }
      updateElement({
        element: newElement
      });
    })
  }

  const initialValues = {
    align: 'left',
    ellipsis: false,
    ...columnSettings
  }


  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_KEY']} name="dataIndex">
            <Input allowClear />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_TITLE']} name="title">
            <Input allowClear />
          </Form.Item>
        </Form>
      </Panel>
      <Panel header={messages['PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_ADVANCED']} key="2">
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_COLUMN_WIDTH']} name="width">
            <InputNumber min={0} max={500} allowClear />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_ELLIPSIS']} name="ellipsis" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_ALIGN']} name="align">
            <Radio.Group size="small">
              <Radio.Button value="left">{messages['PAGEBUIDER_SETTINGS_LEFT']}</Radio.Button>
              <Radio.Button value="center">{messages['PAGEBUIDER_SETTINGS_CENTER']}</Radio.Button>
              <Radio.Button value="right">{messages['PAGEBUIDER_SETTINGS_RIGHT']}</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Panel>
      <Panel header={messages['PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_OTHER']} key="3">
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Tooltip placement="right" title={messages['PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_TIPS']}>
            <Form.Item label={<div className="formbuilder-setting-label-underline">{messages['PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_OPEN_RENDER']}</div>} name="openRender" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Tooltip>
        </Form>
      </Panel>
    </Collapse>
  );
};

export default HeaderCellSettings;
